<template>
  <div class="register-page">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <van-icon name="arrow-left" class="back-icon" @click="back()" />
      <span class="nav-title">{{ $t('auth.register_title') || '歡迎註冊使用' }}</span>
    </div>

    <!-- 注册表单 -->
    <div class="register-form">
      <!-- 账号 -->
      <div class="form-item">
        <label class="form-label">{{ $t('auth.account') || '賬號' }}</label>
        <div class="input-wrapper">
          <input
            v-model="username"
            type="text"
            class="register-input"
            :placeholder="$t('auth.username_place') || '請輸入賬號'"
          />
        </div>
      </div>

      <!-- 密码 -->
      <div class="form-item">
        <div class="label-row">
          <label class="form-label">{{ $t('auth.password') || '密碼' }}</label>
          <span class="show-btn" @click="switchPasswordType('password')">
            {{ passwordType === 'password' ? ($t('auth.show') || '顯示') : ($t('auth.hide') || '隱藏') }}
          </span>
        </div>
        <div class="input-wrapper">
          <input
            v-model="password"
            :type="passwordType"
            class="register-input"
            :placeholder="$t('auth.pwd_place') || '請輸入密碼'"
          />
        </div>
      </div>

      <!-- 確認密码 -->
      <div class="form-item">
        <div class="label-row">
          <label class="form-label">{{ $t('auth.confirm_pwd') || '確認密碼' }}</label>
          <span class="show-btn" @click="switchConfirmPasswordType()">
            {{ confirmPasswordType === 'password' ? ($t('auth.show') || '顯示') : ($t('auth.hide') || '隱藏') }}
          </span>
        </div>
        <div class="input-wrapper">
          <input
            v-model="confirmPassword"
            :type="confirmPasswordType"
            class="register-input"
            :placeholder="$t('auth.confirm_pwd_place') || '請再次輸入密碼'"
          />
        </div>
      </div>

      <!-- 邀请码 -->
      <div class="form-item">
        <label class="form-label">{{ $t('auth.invite_code') || '邀請碼' }}</label>
        <div class="input-wrapper">
          <input
            v-model="code"
            type="text"
            class="register-input"
            :placeholder="$t('auth.invite_code_place') || '請輸入邀請碼'"
          />
        </div>
      </div>

      <!-- 创建账户按钮 -->
      <button class="create-account-btn" @click="doRegister()">
        {{ $t('auth.create_account') || '創建賬戶' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      confirmPassword: '',
      code: '',
      lang: 'en_us',
      passwordType: 'password',
      confirmPasswordType: 'password',
    };
  },
  mounted(){
    this.lang = localStorage.getItem("lang") || 'es_spa';
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    switchConfirmPasswordType() {
      this.confirmPasswordType = this.confirmPasswordType === 'password' ? 'text' : 'password';
    },
    back(){
      return window.history.back();
    },
    doRegister() {
      if(this.username === "" || this.username === null || this.username === undefined){
        this.$toast(this.$t("auth.username_place") || '請輸入賬號');
        return false;
      }
      if(this.password === "" || this.password === null || this.password === undefined){
        this.$toast(this.$t("auth.pwd_place") || '請輸入密碼');
        return false;
      }
      if(this.confirmPassword !== this.password){
        this.$toast(this.$t("auth.pwd_not_match") || '兩次密碼輸入不一致');
        return false;
      }
      if(this.code === "" || this.code === null || this.code === undefined){
        this.$toast(this.$t("auth.invite_code_place") || '請輸入邀請碼');
        return false;
      }
      this.$http({
        method: 'post',
        data:{
          username: this.username,
          password: this.password,
          code: this.code,
          lang: this.lang
        },
        url: 'member_register'
      }).then(res => {
        if(res.code === 200){
          this.$toast(res.msg);
          // localStorage.setItem('token', res.data);
          this.$router.push("Login");
        } else {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if(localStorage.getItem('token')){
      return window.history.back();
    }
  }
};
</script>

<style lang='less' scoped>
.register-page {
  min-height: 100vh;
  background: #1a1a1a;
  padding: 0 20px;
}

/* 顶部导航栏 */
.top-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 0;
  position: relative;
}

.back-icon {
  position: absolute;
  left: 0;
  color: #fff;
  font-size: 40px;
  cursor: pointer;
}

.nav-title {
  color: #00d200;
  font-size: 32px;
}

/* 注册表单 */
.register-form {
  padding-top: 20px;
}

.form-item {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  color: #fff;
  font-size: 32px;
  margin-bottom: 8px;
  font-weight: 500;
}

.label-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.show-btn {
  color: #00d200;
  font-size: 32px;
  cursor: pointer;
}

.input-wrapper {
  background: #3a3a3a;
  border-radius: 6px;
  padding: 0 15px;
  height: 80px;
  display: flex;
  align-items: center;
}

.register-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 28px;
  height: 100%;
  width: 100%;

  &::placeholder {
    color: #888;
  }
}

/* 创建账户按钮 */
.create-account-btn {
  width: 100%;
  height: 80px;
  background: #00d200;
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 32px;
  font-weight: 500;
  cursor: pointer;
  margin-top: 20px;

  &:active {
    opacity: 0.9;
  }
}
</style>
